import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Location', to: '/location' },
];

const services = [
  { label: 'Automotive Tinting', to: '/services' },
  { label: 'Commercial Tinting', to: '/services' },
  { label: 'Residential Tinting', to: '/services' },
  { label: 'Ceramic Tinting', to: '/services' },
  { label: 'Carbon Fiber Installation', to: '/services' },
  { label: 'Window Film', to: '/services' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/82e9787f-6415-42b8-9e52-be199507ad35/9d32c3ec-5bd9-44db-846d-88737afb6501_tint-logo.png?v=b83d4aede8a9172bf74b854a908d18e4"
                alt="TINTSPRO X Logo"
                className="h-14 w-auto object-contain"
                style={{ maxWidth: '200px' }}
              />
            </div>
            <p className="text-white/40 text-sm font-sans leading-relaxed mb-6 max-w-sm">
              Philadelphia&apos;s professional window tinting studio. Expert automotive, residential, and commercial tinting with premium film, UV protection, heat rejection, and precision installation.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-fill text-[#AAFF00] text-sm"></i>
                </div>
                <span className="text-white/45 text-sm font-sans leading-relaxed">
                  3001 Ormes St Unit 05<br />Philadelphia, PA 19134, United States
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-fill text-[#AAFF00] text-sm"></i>
                </div>
                <a
                  href="tel:2155949404"
                  className="text-white/45 text-sm font-sans hover:text-[#AAFF00] transition-colors cursor-pointer"
                >
                  (215) 594-9404
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-fill text-[#AAFF00] text-sm"></i>
                </div>
                <a
                  href="mailto:tintspro2@gmail.com"
                  className="text-white/45 text-sm font-sans hover:text-[#AAFF00] transition-colors cursor-pointer"
                >
                  tintspro2@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2 pt-1">
                <div className="flex items-center gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#AAFF00] text-xs"></i>
                    </div>
                  ))}
                </div>
                <span className="text-white/35 text-xs font-sans">5.0 · Google Reviews</span>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-sans text-sm font-semibold uppercase tracking-[0.15em] mb-5">Pages</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-white/40 text-sm font-sans hover:text-[#AAFF00] transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-sans text-sm font-semibold uppercase tracking-[0.15em] mb-5">Services</h3>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.label}>
                  <Link to={s.to} className="text-white/40 text-sm font-sans hover:text-[#AAFF00] transition-colors">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <a
                href="#estimate"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-[#AAFF00] text-[#080808] text-xs font-sans font-semibold px-5 py-2.5 rounded-full hover:bg-[#C4FF33] transition-colors cursor-pointer"
              >
                Get a Quote
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 px-6 md:px-12 lg:px-16 py-5">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs font-sans">
            © 2025 TINTSPRO X. All rights reserved. Philadelphia, PA.
          </p>
          <p className="text-white/20 text-xs font-sans">
            Automotive Tinting · Commercial Tinting · Residential Tinting · Philadelphia, PA
          </p>
        </div>
      </div>
    </footer>
  );
}
